// Enhanced API URL validation with security checks
export const getApiUrl = () => {
  const envUrl = process.env.REACT_APP_API_URL;

  if (!envUrl || envUrl.trim() === '') {
    return 'http://localhost:3001';
  }

  try {
    const url = new URL(envUrl.trim());

    // Block dangerous protocols
    if (!['http:', 'https:'].includes(url.protocol)) {
      console.warn('Invalid protocol, falling back to localhost:', envUrl);
      return 'http://localhost:3001';
    }

    // In production, require HTTPS
    if (process.env.NODE_ENV === 'production' && url.protocol !== 'https:') {
      console.warn('HTTPS required in production, falling back:', envUrl);
      return 'https://localhost:3001';
    }

    return url.href.replace(/\/$/, ''); // Remove trailing slash
  } catch (error) {
    console.warn('Invalid API URL, falling back to localhost:', envUrl);
    return 'http://localhost:3001';
  }
};
